import React from "react";
import LuxurySpinner from "../components/common/loaders/LuxurySpinner";

function Loader({ size = "medium", text = null, fullScreen = false }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0" }}>
      <LuxurySpinner size={size} text={text} fullScreen={fullScreen} />
    </div>
  );
}

export default Loader;